export const US_ROVER_SUPPORT_NUMBER = '888-453-7889';

export const US_ROVER_EMERGENCY_HOTLINE_NUMBER = '888-727-1140';



// WEBPACK FOOTER //
// ../react-lib/src/constants/phoneNumbers.constants.js